<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs/>
      <div class="content mt-3">
        <div class="animated fadeIn fContainer" v-if="this.hasRole&&hasCompany">
          <!-- content place -->
          <div class="col-lg-12 fColumn">
            <div class="card fColumn">
              <div class="card-header">
                <strong>{{$t('user2company.title')}}</strong>
                <div class="float-right">
                  <!--<template v-if="data.length<=2">-->
                  <!--<router-link :to="{ path: '/company'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('company.new')}}</router-link>-->
                  <!--</template>-->
                  <!--<template v-if="data.length>=2">-->
                  <!--{{$t('company.maxfirmtext')}}-->
                  <!--</template>-->
                </div>
              </div>


              <div class="card-body card-block">
                <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :msgPre="AlertInPage.msgPre" :msgPost="AlertInPage.msgPost" :delay="AlertInPage.delay"/>
                <!--<AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>-->
                <!--<AlertInPage />-->
                <!--<AlertInPage type="success" msg="msg" delay="2000"/>-->
                <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">
                  <div class="alert alert-warning">{{ $t('user2company.attentiontext') }}</div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="email" class=" form-control-label">{{ $t('user2company.newUserEmail') }} </label></div>
                    <div class="col-12 col-md-9">
                      <table class="w100">
                        <tr>
                          <td>
                            <input v-model="dataform.email" type="text" id="email" placeholder="" class="form-control" name="dataform.email"
                                   v-validate="'required'" v-bind:class="{'is-invalid':errors.has('dataform.email')}">
                            <small class="form-text text-muted"></small>
                          </td>
                          <td class="w1">
                            <div class="col pr-0">
                              <button type="button" class="btn btn-success btn-sm" v-on:click="getUserByEmailAndSave()">
                                <i class="fa fa-search"></i> {{$t('user2company.addUser')}}
                              </button>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </form>
              </div>
              <!--<div class="card-footer">-->
              <!--<button type="button" class="btn btn-success btn-sm" v-on:click="save()">-->
              <!--<i class="fa fa-save"></i> {{$t('global.add')}}-->
              <!--</button>-->
              <!--</div>-->
              <hr>

              <div class="card-body card-block fColumn">
                <div class="fContent">
                  <TableDatatableJs :head="head" :data="data"/>

                </div>
              </div>
            </div>
          </div>

        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>
</template>

<script>
  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import TableDatatableJs from '@/components/TableDatatableJs.vue';
  import MenuToggle from '@/components/MenuToggle.vue';
  import Helper from '@/helper/Helper';
  import Api from '@/api/Api';
  import AlertInPage from '@/components/AlertInPage.vue';

  //  id_store 	wsid 	text
  export default {
    name: 'User2company',
    data() {
      const modul = this;
      return {
//        moduleRights: [],
        Helper: Helper
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 2500,
        }
        ,

        dataform: {},
        data: [],
        head: [
          {
            key: "user2company_id_user",
            title: "user2role.title",
            data: "user2company_id_user",


            linkclass: "text-nowrap",
            linktext: "global.edit",
            linkiconclass: "menu-icon fa fa-users",
            linkfn: function (data, type, row, meta) { // data, type, row, meta
              return modul.handleRolesHandler(data, type, row, meta);
            }
          }
          , {
            key: "user2company_id",
            title: "global.delete",
            data: "user2company_id",


            linkclass: "text-nowrap",
            linktext: "global.remove",
            linkiconclass: "menu-icon fa fa-remove",
            linkfn: function (data, type, row, meta) { // data, type, row, meta
              return modul.removeUserHandler(data, type, row, meta);
            }
          }
          , {
            key: "users_email",
            title: "company.usermail"
          }
          , {
            key: "company_name",
            title: "company.companyname"
          }
//          , {
//            key: "deleted",
//            title: "global.deleted"
//          }
        ]
        , breadcrumbstitle: 'user2company.title'
        , breadcrumbsData: [
          {
            'title': "user2company.title",
          },
        ]
        , hasRole: false
        , hasCompany: false

      };
    },
    watch: {
      '$store.state.userhash': function (newVal, oldVal) {
        const modul = this;
        modul.handleRights();
      },
//      '$store.state.id_company': function (newVal, oldVal) {
//        const modul = this;
//        modul.handleRights();
//      },
      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          modul.getElements();
        }
      },
      '$store.state.id_company': function (newVal, oldVal) {
        const modul = this;
        modul.getElements();
      },

    },
    mounted() {
      console.log("mounted")
      const modul = this;
      modul.handleRights();
    },
    methods: {
      handleRights(){
        const modul = this;
        if (modul.$store.state.user && modul.$store.state.user.role === "ADMIN") {
          modul.hasRole = true;
        }
        if (modul.$store.state.id_company) {
          modul.hasCompany = true;
        }
      },
      getElements(){
        const modul = this;
        if (!modul.$store.state.id_company) {
          setTimeout(function (e) {
            modul.AlertInPage.msg = "user2company.id_company_error";
            modul.AlertInPage.msgPost = "";
            modul.AlertInPage.type = "success";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
              modul.AlertInPage.msgPost = "";
            }, Number(2000));
          }, Number(300));
        } else {
          modul.AlertInPage.msg = "form.in_progress";
          modul.AlertInPage.type = "warning";
          Api.getUser2companies({id_company: modul.$store.state.id_company}).then(function (res) {
            if (res && res.result) {
              console.log(res);
              modul.data = Array.from(res.data);
            } else {
              console.log(res)
              modul.AlertInPage.msg = "form.error";
              modul.AlertInPage.msgPost = (res.message) ? res.message : "";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
                modul.AlertInPage.msgPost = "";
              }, Number(modul.AlertInPage.delay));
            }
          }, function (e) {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          });
        }
      },
      removeUserHandler: function (event, data, type, row, meta) {
        const modul = this;
        if (confirm(modul.$t("user2company.confirm"))) {

        console.log(row.user2company_id);
        const req = {};
        req.id = row.user2company_id;
        req.data = {};
        req.data.id_company = row.user2company_id_company;
        req.data.id_user = row.user2company_id_user;
        console.log(row);
        req.id_company = modul.$store.state.id_company;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.removeUserFromCompany(req).then(function (res) {
          if (res && res.result && res.data && res.data.affected) {
            modul.getElements();
            modul.AlertInPage.msg = "form.succes";
            modul.AlertInPage.type = "success";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));

          } else {
            console.log(res)
            modul.AlertInPage.msg = "form.error";
            modul.AlertInPage.msgPost = (res.message) ? res.message : "";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
              modul.AlertInPage.msgPost = "";
            }, Number(modul.AlertInPage.delay));
          }
        }, function (e) {
          modul.AlertInPage.msg = "form.save_error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });

      }
        return modul.$t("global.remove");
      },
      handleRolesHandler: function (event, data, type, row, meta) {
        const modul = this;
        console.log(row.user2company_id_user);
        modul.$router.push({
          path: '/user2role/'+row.user2company_id_user
//            name: "user2role", params: {id: row.user2company_id_user}
        });


//        return modul.$t("global.remove");
      },
      getUserByEmailAndSave(){
        const modul = this;
        const req = {};
        req.data = modul.dataform.email;
        req.id_company = modul.$store.state.id_company;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.getUserByEmail(req).then(function (res) {
          if (res && res.result && res.data) {
            console.log(res);
            if (res.data && res.data.id) {
              modul.save({email: res.data.id, id: res.data.id});
            } else {
              modul.AlertInPage.msg = "form.search_error";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(modul.AlertInPage.delay));
            }
          } else {
            console.log(res)
            modul.AlertInPage.msg = "form.error";
            modul.AlertInPage.msgPost = (res.message) ? res.message : "";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
              modul.AlertInPage.msgPost = "";
            }, Number(modul.AlertInPage.delay));

          }
        }, function (e) {
          modul.AlertInPage.msg = "form.save_error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });
      },
      save(emailData){
        const modul = this;
        if (emailData) {
          const data = Helper.makeFilteredObjectByKeys(emailData, ["id", "email"]);
          const req = {};
          req.data = data;
          req.id = data.id;
          req.id_company = modul.$store.state.id_company;
          modul.AlertInPage.msg = "form.in_progress";
          modul.AlertInPage.type = "warning";
          Api.saveUser2company(req).then(function (res) {
            if (res && res.result) {
              modul.getElements();
              modul.AlertInPage.msg = "form.save_succes";
              modul.AlertInPage.type = "success";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
//                modul.$router.push({path: "/companies"})
              }, Number(modul.AlertInPage.delay));
            } else {
              modul.AlertInPage.msg = "form.save_error";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(modul.AlertInPage.delay));
            }
          }, function (e) {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          });

        } else {
          modul.AlertInPage.msg = "form.save_error";
          modul.AlertInPage.type = "danger";
        }

      }
    },
    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      TableDatatableJs,
      MenuToggle,
      AlertInPage,
    },
  };
</script>








